export default "__VITE_ASSET__CCOa08Ly__"